import {
  Box,
  Container,
  Typography,
  Grid,
  IconButton,
  Stack,
  Paper,
  Avatar,
  Divider,
} from '@mui/material';
import {
  Email,
  Phone,
  LocationOn,
  LinkedIn,
  GitHub,
  ContactMail,
  Launch,
  Code,
  Work,
  Psychology,
  Terminal,
} from '@mui/icons-material';
import { useThemeMode } from '../contexts/ThemeContext';

const Contact = () => {
  const { darkMode } = useThemeMode();

  const contactInfo = [
    {
      icon: <Email />,
      title: 'Email',
      value: 'iyogesh.more1998@gmail.com',
      link: 'mailto:iyogesh.more1998@gmail.com',
      color: '#ea4335',
    },
    {
      icon: <Phone />,
      title: 'Phone',
      value: '+91 8850055197',
      link: 'tel:+918850055197',
      color: '#34a853',
    },
    {
      icon: <LocationOn />,
      title: 'Location',
      value: 'Mumbai, India',
      link: '#',
      color: '#fbbc04',
    },
  ];

  const socialLinks = [
    {
      icon: <LinkedIn />,
      url: 'https://www.linkedin.com/in/yogesh-more-28b663266',
      color: '#0077b5',
      label: 'LinkedIn',
    },
    {
      icon: <GitHub />,
      url: 'https://github.com/iamyogeshmore',
      color: darkMode ? '#fff' : '#333',
      label: 'GitHub',
    },
    {
      icon: <Terminal />,
      url: 'https://leetcode.com/u/iamyogeshmore/',
      color: '#ffa116',
      label: 'LeetCode',
    },
    {
      icon: <Psychology />,
      url: 'https://www.hackerrank.com/profile/iyogesh_more',
      color: '#00ea64',
      label: 'HackerRank',
    },
  ];

  const quickActions = [
    {
      icon: <Work />,
      title: 'Hire Me',
      description: 'Available for freelance projects',
      action: () => window.open('mailto:iyogesh.more1998@gmail.com?subject=Freelance Opportunity', '_blank'),
      color: '#1976d2',
    },
    {
      icon: <Code />,
      title: 'View Work',
      description: 'Check out my repositories',
      action: () => window.open('https://github.com/iamyogeshmore', '_blank'),
      color: '#dc004e',
    },
    {
      icon: <Launch />,
      title: 'Resume',
      description: 'Download my latest resume',
      action: () => window.open('/Yogesh_More_Resume.pdf', '_blank'),
      color: '#9c27b0',
    },
  ];

  return (
    <Box id="contact" sx={{
      py: 2,
      backgroundColor: darkMode
        ? 'rgba(156, 39, 176, 0.02)'
        : 'rgba(156, 39, 176, 0.01)'
    }}>
      <Container maxWidth="xl" sx={{ px: { xs: 2, sm: 3, md: 4 } }}>
        <Box sx={{ textAlign: 'center', mb: 6 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 2, mb: 2 }}>
            <ContactMail sx={{ fontSize: 32, color: 'primary.main' }} />
            <Typography
              variant="h2"
              sx={{
                fontSize: { xs: '2rem', md: '2.5rem' },
                fontWeight: 800,
                background: 'linear-gradient(45deg, #1976d2, #dc004e)',
                backgroundClip: 'text',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
              }}
            >
              Get In Touch
            </Typography>
          </Box>
          <Typography
            variant="body1"
            sx={{
              color: 'text.secondary',
              maxWidth: 600,
              mx: 'auto',
              fontSize: '1.1rem',
            }}
          >
            Let's connect and discuss opportunities to work together
          </Typography>
        </Box>

        {/* Contact Information - Centered and Attractive */}
        <Box sx={{ display: 'flex', justifyContent: 'center', mb: 6 }}>
          <Paper
            elevation={0}
            sx={{
              p: { xs: 4, md: 6 },
              width: '100%',
              background: darkMode
                ? 'linear-gradient(135deg, rgba(255, 255, 255, 0.1) 0%, rgba(255, 255, 255, 0.05) 100%)'
                : 'linear-gradient(135deg, rgba(255, 255, 255, 0.95) 0%, rgba(248, 250, 252, 0.95) 100%)',
              border: darkMode
                ? '1px solid rgba(255, 255, 255, 0.15)'
                : '1px solid rgba(0, 0, 0, 0.08)',
              borderRadius: 6,
              boxShadow: darkMode
                ? '0 20px 40px rgba(0, 0, 0, 0.3)'
                : '0 20px 40px rgba(0, 0, 0, 0.1)',
              backdropFilter: 'blur(10px)',
            }}
          >


            {/* Contact Info Cards - Centered Row */}
            <Grid container spacing={{ xs: 2, sm: 3 }} sx={{ mb: 5, justifyContent: 'center' }}>
              {contactInfo.map((info, index) => (
                <Grid item xs={12} sm={6} md={4} key={index}>
                  <Box
                    component={info.link !== '#' ? 'a' : 'div'}
                    href={info.link !== '#' ? info.link : undefined}
                    sx={{
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      textAlign: 'center',
                      p: { xs: 3, sm: 4 },
                      borderRadius: 4,
                      cursor: info.link !== '#' ? 'pointer' : 'default',
                      textDecoration: 'none',
                      color: 'inherit',
                      background: darkMode
                        ? 'rgba(255, 255, 255, 0.08)'
                        : 'rgba(255, 255, 255, 0.7)',
                      border: `2px solid ${info.color}20`,
                      transition: 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
                      position: 'relative',
                      overflow: 'hidden',
                      '&::before': {
                        content: '""',
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        right: 0,
                        height: '4px',
                        background: `linear-gradient(90deg, ${info.color}, ${info.color}80)`,
                        transform: 'scaleX(0)',
                        transformOrigin: 'left',
                        transition: 'transform 0.4s ease',
                      },
                      '&:hover': {
                        color: info.link !== '#' ? info.color : 'inherit',
                        background: darkMode
                          ? `${info.color}15`
                          : `${info.color}08`,
                        border: `2px solid ${info.color}60`,
                        transform: 'translateY(-8px) scale(1.02)',
                        boxShadow: `0 12px 32px ${info.color}25`,
                        '&::before': {
                          transform: 'scaleX(1)',
                        },
                      },
                    }}
                  >
                    <Avatar
                      sx={{
                        bgcolor: info.color,
                        width: { xs: 50, sm: 60 },
                        height: { xs: 50, sm: 60 },
                        mb: 3,
                        boxShadow: `0 8px 20px ${info.color}40`,
                      }}
                    >
                      {info.icon}
                    </Avatar>
                    <Typography
                      variant="subtitle2"
                      sx={{
                        fontSize: '0.85rem',
                        color: 'text.secondary',
                        fontWeight: 700,
                        textTransform: 'uppercase',
                        letterSpacing: 1,
                        mb: 1,
                      }}
                    >
                      {info.title}
                    </Typography>
                    <Typography
                      variant="body1"
                      sx={{
                        fontWeight: 600,
                        fontSize: '1.1rem',
                        color: 'text.primary',
                        wordBreak: 'break-word',
                      }}
                    >
                      {info.value}
                    </Typography>
                  </Box>
                </Grid>
              ))}
            </Grid>

            <Divider
              sx={{
                my: 4,
                borderColor: darkMode ? 'rgba(255, 255, 255, 0.15)' : 'rgba(0, 0, 0, 0.1)',
                '&::before, &::after': {
                  borderColor: darkMode ? 'rgba(255, 255, 255, 0.15)' : 'rgba(0, 0, 0, 0.1)',
                }
              }}
            />

            {/* Social Media Section */}
            <Box sx={{ textAlign: 'center' }}>
              <Box sx={{ textAlign: 'center', mt: 6 }}>
                <Typography
                  variant="h6"
                  sx={{
                    mb: 3,
                    fontWeight: 600,
                    color: 'primary.main',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: 1,
                  }}
                >
                  <Terminal sx={{ fontSize: 20 }} />
                  Follow My Journey
                </Typography>

                <Stack
                  direction="row"
                  spacing={2}
                  justifyContent="center"
                  sx={{ flexWrap: 'wrap', gap: 2 }}
                >
                  {/* LinkedIn */}
                  <IconButton
                    component="a"
                    href="https://www.linkedin.com/in/yogesh-more-28b663266"
                    target="_blank"
                    rel="noopener noreferrer"
                    sx={{
                      width: 60,
                      height: 60,
                      background: darkMode
                        ? 'rgba(255, 255, 255, 0.08)'
                        : 'rgba(255, 255, 255, 0.9)',
                      border: '1px solid rgba(0, 119, 181, 0.3)',
                      transition: 'all 0.3s ease',
                      '&:hover': {
                        transform: 'translateY(-4px) scale(1.1)',
                        boxShadow: '0 8px 25px rgba(0, 119, 181, 0.3)',
                        border: '1px solid rgba(0, 119, 181, 0.6)',
                      },
                    }}
                  >
                    <LinkedIn sx={{ fontSize: 28, color: '#0077b5' }} />
                  </IconButton>

                  {/* GitHub */}
                  <IconButton
                    component="a"
                    href="https://github.com/iamyogeshmore"
                    target="_blank"
                    rel="noopener noreferrer"
                    sx={{
                      width: 60,
                      height: 60,
                      background: darkMode
                        ? 'rgba(255, 255, 255, 0.08)'
                        : 'rgba(255, 255, 255, 0.9)',
                      border: darkMode
                        ? '1px solid rgba(255, 255, 255, 0.3)'
                        : '1px solid rgba(51, 51, 51, 0.3)',
                      transition: 'all 0.3s ease',
                      '&:hover': {
                        transform: 'translateY(-4px) scale(1.1)',
                        boxShadow: darkMode
                          ? '0 8px 25px rgba(255, 255, 255, 0.3)'
                          : '0 8px 25px rgba(51, 51, 51, 0.3)',
                        border: darkMode
                          ? '1px solid rgba(255, 255, 255, 0.6)'
                          : '1px solid rgba(51, 51, 51, 0.6)',
                      },
                    }}
                  >
                    <Box
                      component="img"
                      src="/icons/GitHub.png"
                      alt="GitHub"
                      sx={{
                        width: 28,
                        height: 28,
                        filter: darkMode ? 'invert(1)' : 'none',
                      }}
                    />
                  </IconButton>

                  {/* LeetCode */}
                  <IconButton
                    component="a"
                    href="https://leetcode.com/u/iamyogeshmore/"
                    target="_blank"
                    rel="noopener noreferrer"
                    sx={{
                      width: 60,
                      height: 60,
                      background: darkMode
                        ? 'rgba(255, 255, 255, 0.08)'
                        : 'rgba(255, 255, 255, 0.9)',
                      border: '1px solid rgba(255, 193, 7, 0.3)',
                      transition: 'all 0.3s ease',
                      '&:hover': {
                        transform: 'translateY(-4px) scale(1.1)',
                        boxShadow: '0 8px 25px rgba(255, 193, 7, 0.3)',
                        border: '1px solid rgba(255, 193, 7, 0.6)',
                      },
                    }}
                  >
                    <Box
                      component="img"
                      src="/icons/Leetcode_Logo.png"
                      alt="LeetCode"
                      sx={{
                        width: 28,
                        height: 28,
                        objectFit: 'contain'
                      }}
                    />
                  </IconButton>

                  {/* HackerRank */}
                  <IconButton
                    component="a"
                    href="https://www.hackerrank.com/profile/iyogesh_more"
                    target="_blank"
                    rel="noopener noreferrer"
                    sx={{
                      width: 60,
                      height: 60,
                      background: darkMode
                        ? 'rgba(255, 255, 255, 0.08)'
                        : 'rgba(255, 255, 255, 0.9)',
                      border: '1px solid rgba(0, 234, 100, 0.3)',
                      transition: 'all 0.3s ease',
                      '&:hover': {
                        transform: 'translateY(-4px) scale(1.1)',
                        boxShadow: '0 8px 25px rgba(0, 234, 100, 0.3)',
                        border: '1px solid rgba(0, 234, 100, 0.6)',
                      },
                    }}
                  >
                    <Box
                      component="img"
                      src="/icons/HackerRank_Icon-1000px.png"
                      alt="HackerRank"
                      sx={{
                        width: 28,
                        height: 28,
                        objectFit: 'contain'
                      }}
                    />
                  </IconButton>
                </Stack>
              </Box>

            </Box>
          </Paper>
        </Box>


      </Container>
    </Box>
  );
};

export default Contact;